import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const IconTooltip = () => {
    return (
        <svg
            className='icon-tooltip'
            fill='none'
            height='20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'>
            <mask
                height='20'
                id='a'
                maskUnits='userSpaceOnUse'
                // style='mask-type:alpha'
                width='20'
                x='0'
                y='0'>
                <path
                    d='M0 0h20v20H0z'
                    fill='#D9D9D9'/>
            </mask>
            <g mask='url(#a)'>
                <path
                    d='M10.0046 6.22437c-.16588 0-.30637.0561-.42148.1683-.11511.11219-.17267.25121-.17267.41706 0 .16584.0561.30632.1683.42144.11218.11511.25119.17266.41704.17266.16581 0 .30631-.05609.42141-.16827.1152-.11219.1727-.25122.1727-.41706 0-.16585-.0561-.30633-.1683-.42146-.1122-.11511-.2512-.17267-.417-.17267Zm.5372 2.71153H9.45854v5h1.08326v-5Zm-.54876-6.51921c1.04326 0 2.02576.19736 2.94746.59208.9218.39472 1.7286.93785 2.4205 1.62938.6919.69154 1.2352 1.4977 1.6301 2.41847.3949.92078.5924 1.90462.5924 2.95148 0 1.047-.1974 2.0278-.5921 2.9427-.3947.9148-.9378 1.7182-1.6294 2.41-.6915.6919-1.4977 1.2353-2.4184 1.6302-.9208.3949-1.9047.5923-2.95156.5923-1.04692 0-2.0278-.1973-2.94263-.5921-.91485-.3947-1.71819-.9378-2.41004-1.6293-.69186-.6916-1.23524-1.4961-1.63014-2.4137-.39491-.9175-.59236-1.8978-.59236-2.9411 0-1.04318.19736-2.02568.59208-2.94746.39473-.92179.93785-1.72861 1.62938-2.42045.69154-.69186 1.49608-1.23525 2.4136-1.63015.91753-.3949 1.8979-.59235 2.94111-.59235ZM10.0002 3.5c-1.80557 0-3.34029.63194-4.60418 1.89583C4.13213 6.65972 3.50018 8.19444 3.50018 10c0 1.8056.63195 3.3403 1.89584 4.6042C6.65991 15.8681 8.19463 16.5 10.0002 16.5c1.8055 0 3.3403-.6319 4.6042-1.8958 1.2638-1.2639 1.8958-2.7986 1.8958-4.6042 0-1.80556-.632-3.34028-1.8958-4.60417C13.3405 4.13194 11.8057 3.5 10.0002 3.5Z'
                    fill='#0E0E0E'/>
            </g>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconTooltip;
